import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type SceneState = {
  hover?: string;
  selection?: string;
  sceneLoading?: boolean;
};

const initialState: SceneState = {
  hover: undefined,
  selection: undefined,
  sceneLoading: false,
};

const editorSceneSlice = createSlice({
  name: 'editorScene',
  initialState,
  reducers: {
    clear: state => {
      state.hover = undefined;
      state.selection = undefined;
    },
    setHover: (state, action: PayloadAction<string | undefined>) => {
      state.hover = action.payload;
    },
    setSelection: (state, action: PayloadAction<string | undefined>) => {
      state.selection = action.payload;
    },
    setSceneLoading: (state, action: PayloadAction<boolean>) => {
      state.sceneLoading = action.payload;
    },
  },
});

export const { clear, setHover, setSelection, setSceneLoading } = editorSceneSlice.actions;

export const editorSceneReducer = editorSceneSlice.reducer;
